module.exports = __webpack_public_path__ + "static/img/ls11.809ffe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls11.png
// module id = 4AUE
// module chunks = 12